
































































































import { debounce } from "lodash";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Input, Datepicker, SvgIcon } from "@brankas/web-ui";

export interface FormFilters {
  accountNo?: string;
  minAmount?: number;
  maxAmount?: number;
  fromDate?: Date;
  toDate?: Date;
}

@Component({
  components: {
    Input,
    Datepicker,
    SvgIcon,
  },
})
export default class TransactionFilters extends Vue {
  filters: FormFilters = {
    accountNo: "",
    minAmount: undefined,
    maxAmount: undefined,
    fromDate: undefined,
    toDate: undefined,
  };

  datePickerRules: any = {
    disabled: {
      start: {
        from: null,
        to: null,
      },
      end: {
        from: null,
        to: null,
      },
    },
  };

  private onFilterChanges = debounce(() => {
    this.$emit("filters-changed", this.filters);
  }, 500);

  @Watch("filters", { deep: true })
  watchFiltersChanged() {
    this.onFilterChanges();
  }

  /**
   * Watch selected Start and End date to ensure
   * that the user will only be able to select valid
   * dates
   */

  @Watch("filters.fromDate")
  onStartDateChange(value: Date | null) {
    if (value) {
      this.datePickerRules.disabled.end.to = value;
    } else {
      this.datePickerRules.disabled.end = {
        from: new Date(),
        to: null,
      };
    }
  }

  @Watch("filters.toDate")
  onEndDateChange(value: Date | null) {
    if (value) {
      this.datePickerRules.disabled.start.from = value;
    } else {
      this.datePickerRules.disabled.start = {
        from: new Date(),
        to: null,
      };
    }
  }
}
